import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { CalloutHero } from 'marketplace-discovery-studio-lib/components/CalloutHero';
import { CalloutCard } from 'marketplace-discovery-studio-lib/components/CalloutCard';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { Subscreens } from '../../constants/usage';
import { PageCalloutBannerCard } from './PageCalloutBannerCard';
import { HeroButton } from './HeroButton';
import { FindPartnerMatch } from './FindPartnerMatch';
import { useIsOpenState } from '../hooks/useIsOpenState';
import { getCalloutCta, useCurrentPageId, usePagePlacements } from '../hooks/usePagePlacements';

// NOTE (MKTD-808): much of this is temporary glue to ship the Workflows
// release. Once the studio is fully released, getPlacements should return
// render-ready content and this can be simplified to render it as-is.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PageCallouts({
  showBanners = true
}) {
  const pageId = useCurrentPageId();
  const {
    placementsBySection,
    loading
  } = usePagePlacements(pageId);
  const {
    open,
    isOpen,
    close
  } = useIsOpenState();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  if (loading || !pageId) {
    return null;
  }
  const topHero = placementsBySection['TOP_HERO'];
  const topCard = placementsBySection['TOP_CARD'];
  const banners = showBanners ? ['BANNER_1', 'BANNER_2'].map(section => placementsBySection[section]).filter(Boolean) : [];
  const hasTopRow = Boolean(topHero || topCard);
  if (!hasTopRow && banners.length === 0) {
    return null;
  }
  const heroCta = topHero ? getCalloutCta(topHero) : undefined;
  const hasSecondaryButton = Boolean((heroCta === null || heroCta === void 0 ? void 0 : heroCta.secondaryButtonText) && (heroCta === null || heroCta === void 0 ? void 0 : heroCta.secondaryButtonUrl));
  const cardCta = topCard ? getCalloutCta(topCard) : undefined;
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "600",
    children: [hasTopRow && /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      gap: "400",
      marginBlockEnd: banners.length > 0 ? '400' : '0',
      alignItems: "stretch",
      children: [topHero && /*#__PURE__*/_jsx(View, {
        flex: "2",
        minBlockSize: topCard ? '340px' : undefined,
        children: /*#__PURE__*/_jsx(CalloutHero, {
          title: topHero.calloutContent.title,
          description: topHero.calloutContent.description,
          buttonText: topHero.calloutContent.buttonText,
          buttonUrl: topHero.calloutContent.buttonUrl,
          buttonUse: hasSecondaryButton ? 'primary' : 'secondary',
          secondaryButtonText: heroCta === null || heroCta === void 0 ? void 0 : heroCta.secondaryButtonText,
          secondaryButtonUrl: heroCta === null || heroCta === void 0 ? void 0 : heroCta.secondaryButtonUrl,
          openCopilot: heroCta === null || heroCta === void 0 ? void 0 : heroCta.openCopilot,
          onClick: () => {
            trackMarketplaceEvent(getMarketplaceInteractionEvent({
              action: 'hero button clicked',
              subscreen: Subscreens.HERO_SECTION
            }));
            if (heroCta !== null && heroCta !== void 0 && heroCta.openFindPartnerMatch) {
              open();
            }
          },
          imageUrl: topHero.calloutContent.imageUrl,
          videoId: topHero.calloutContent.videoId,
          CtaButton: HeroButton
        })
      }), topCard && /*#__PURE__*/_jsx(View, {
        flex: "1",
        minBlockSize: "340px",
        children: /*#__PURE__*/_jsx(CalloutCard, {
          title: topCard.calloutContent.title,
          buttonText: topCard.calloutContent.buttonText,
          buttonUrl: topCard.calloutContent.buttonUrl,
          imageUrl: topCard.calloutContent.imageUrl,
          imageAlt: topCard.calloutContent.title,
          videoId: topCard.calloutContent.videoId,
          openCopilot: cardCta === null || cardCta === void 0 ? void 0 : cardCta.openCopilot,
          CtaButton: HeroButton
        })
      })]
    }), banners.length > 0 && /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "400",
      children: banners.map(banner => /*#__PURE__*/_jsx(PageCalloutBannerCard, {
        placement: banner
      }, banner.section))
    }), isOpen && /*#__PURE__*/_jsx(FindPartnerMatch, {
      onClose: close
    })]
  });
}